import {notificationsApi} from "./notifications-api";
import {setNotifications} from "./notifications-actions";
import {setToken} from "../auth/auth-actions";
import instance from "../instance";


export const getNotifications = () => async (dispatch) => {
  try {
    const response = await notificationsApi.getNotifications()
    dispatch(setNotifications(response.data))
  } catch (e) {
    // localStorage.removeItem('token')
    // dispatch(setToken(false))
  }
}

export const readNotifications = (notificationId, is_active) => async (dispatch) => {
  const response = await notificationsApi.readNotification(notificationId, is_active)
  console.log(response.data)
  dispatch(getNotifications())
}